import { getRouteApi } from "@tanstack/react-router";
import { defaultFirmContact, type FirmContact } from "@/lib/firm-contact";

const rootRoute = getRouteApi("__root__");

export function useFirmContact(): FirmContact {
  const settings = rootRoute.useLoaderData();
  return settings.firmContact ?? defaultFirmContact;
}
